import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigurationService } from '../../services/configuration.service';
import { Observable } from 'rxjs';
import { ActivityType } from '../models/activity-type.model';
import { RepActivity } from '../models/rep-activity.model';
@Injectable({
  providedIn: 'root'
})
export class RepActivityApiService {

  constructor(protected readonly http: HttpClient,
    protected readonly configurations: ConfigurationService) { }

  getAllActivityTypes(isServiceRequest = false): Observable<ActivityType[]> {
    let myParams = new HttpParams()
      .set("isServiceRequest", isServiceRequest.toString())
    return this.http.get<ActivityType[]>(`${this.configurations.apiAddress}/api/repActivityType/getAll`, { params: myParams });
  }

  getUserActivityTypes(isServiceRequest = false): Observable<ActivityType[]> {
    let myParams = new HttpParams()

      .set("isServiceRequest", isServiceRequest.toString())
    return this.http.get<ActivityType[]>(`${this.configurations.apiAddress}/api/repActivityType/getUserActivityTypes`, { params: myParams });
  }


  saveActivity(activity): Observable<number> {
    return this.http.post<number>(`${this.configurations.apiAddress}/api/repActivity/save`, activity);
  }

  searchRepActivities(title: string, isDeleted: boolean = false, businessUnitId = undefined, isServiceRequest = false): Observable<RepActivity[]> {
    let myParams = new HttpParams()
      .set("isDeleted", isDeleted.toString())
      .set("isServiceRequest", isServiceRequest.toString())
      .set('businessUnitId', businessUnitId == undefined ? "0" : businessUnitId)
      .set("title", title === undefined ? "" : title);

    return this.http.get<RepActivity[]>(`${this.configurations.apiAddress}/api/repActivity/searchRepActivities`, { params: myParams });
  }

  getPendingApproval(title: string, isServiceRequest = false): Observable<RepActivity[]> {
    let myParams = new HttpParams()
      .set("isServiceRequest", isServiceRequest.toString())
      .set("title", title === undefined ? "" : title);
    return this.http.get<RepActivity[]>(`${this.configurations.apiAddress}/api/repActivity/getPendingApproval`, { params: myParams });
  }

  getRepActivityDetails(id): Observable<RepActivity> {
    return this.http.get<RepActivity>(`${this.configurations.apiAddress}/api/repActivity/repActivityDetails/${id}`);
  }

  deleteRepActivity(id): Observable<boolean> {
    return this.http.post<boolean>(`${this.configurations.apiAddress}/api/repActivity/deleteRepActivity/${id}`, null);
  }

  saveActivityAttendees(activity): Observable<number> {
    return this.http.post<number>(`${this.configurations.apiAddress}/api/repActivity/saveActivityAttendees`, activity);
  }

  downloadCsvTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/repActivity/downloadCSVTemplate", { responseType: "blob" });

  }

  getHcpActivities(dateFrom, dateTo, hcpId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/repActivity/getHcpActivities`, { params: myParams })
  }

  getHcoActivities(dateFrom, dateTo, hcoId) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/repActivity/getHcoActivities`, { params: myParams })
  }

  getTotalHcpActivitiesCount(hcpId?, isServiceRequest?) {
    let myParams = new HttpParams()
      .set('isServiceRequest', isServiceRequest == undefined ? "" : isServiceRequest.toString())
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/repActivity/getTotalHcpActivitiesCount`, { params: myParams })
  }

  getTotalHcoActivitiesCount(hcoId, isServiceRequest) {
    let myParams = new HttpParams()
      .set('isServiceRequest', isServiceRequest == undefined ? "" : isServiceRequest.toString())
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/repActivity/getTotalHcoActivitiesCount`, { params: myParams })
  }

}
